import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-modal-loading-overlay',
  templateUrl: './modal-loading-overlay.component.html',
  styleUrls: ['./modal-loading-overlay.component.scss']
})
export class ModalLoadingOverlayComponent {
  @Input() public progress?: number;
  @Input() public status?: String = 'Please, wait!';
  @Input() public showProgress: boolean = false;
  @Input() public showStatus: boolean = false;
}
